export class Interstitial {
    public get ObjectName(): string { return 'Interstitial'; }
    public Message;

    constructor(fsSource: any) {
        this.Message = fsSource.Message;
    }
}
